"use strict";
/**
 * Copyright © 2023 650 Industries.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", { value: true });
require("./location/install");
// IMPORT POSITION MATTERS FOR FAST REFRESH ON WEB
require("./effects");
// vvv EVERYTHING ELSE vvv
require("./async-require");
//# sourceMappingURL=index.js.map